import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

const Store = props => {
  return (
    <Content
      style={{
        margin: '24px 16px',
        padding: 24,
        background: '#fff',
        minHeight: 280,
      }}
    >
      Store
    </Content>
  );
};

export default Store;
